<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('withdraw.log')" class="custom-nav-bar">
        <template #left>
          <van-icon name="arrow-left" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-empty v-if="list.length === 0 && !loading" :description="$t('common.nodata')" class="custom-empty" />
      <van-list v-else
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('common.nomore')"
          @load="onLoad">
            <div class="list-container">
            <van-cell-group class="custom-cell-group">
          <van-cell v-for="(item,i) in list" :key="i" class="custom-cell">
            <template #title>
              <div class="cell-header">
                <div class="cell-left">
                  <span class="title-text">{{$t('withdraw.title')}}</span>
                  <span class="amount">{{item.money}} TRY</span>
                </div>
                <div class="cell-middle">
                  <span class="status" :class="getStatusClass(item.status)">
                    {{getStatusText(item.status)}}
                  </span>
                </div>
                <div class="cell-right">
                  <span class="notification-btn" @click="showD(item.desc)">{{$t('notification')}}</span>
                </div>
              </div>
              <div class="time-label">{{item.create_time}}</div>
            </template>
          </van-cell>
            </van-cell-group>
            </div>
      </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';

export default {
  data() {
    return {
      page: 1,
      refreshing: false,
      count: 0,
      limit: 10,
      loading: false,
      finished: false,
      list: [],
      statusExt: ['', this.$t('withdraw.status1'), this.$t('withdraw.status2'), this.$t('withdraw.status3')],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    
    onRefresh() {
      // 重置分页数据
      this.page = 1;
      this.finished = false;
      this.loading = true;
      
      // 重新加载数据
      this.getUserWithdrawList(true);
    },
    
    onLoad() {
      // 加载更多数据
      if (this.finished) return;
      
      this.page++;
      this.getUserWithdrawList(false);
    },
    
    showD(desc) {
      Dialog.alert({
        title: this.$t('notification'),
        message: desc,
      });
    },
    
    getUserWithdrawList(isRefresh = false) {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_list',
        params: {
          page: this.page,
          limit: this.limit
        }
      }).then(res => {
        if (res.code === 200) {
          if (isRefresh) {
            // 刷新时替换整个列表
            this.list = res.data || [];
          } else {
            // 加载更多时追加数据
            this.list = [...this.list, ...(res.data || [])];
          }
          
          // 更新分页状态
          this.count = res.count || 0;
          
          // 判断是否已加载完成
          if (!res.data || res.data.length < this.limit) {
            this.finished = true;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
          this.$router.push('/Login');
        } else {
          this.$toast(res.msg || this.$t('common.loadFail'));
        }
      }).catch(error => {
        this.$toast(this.$t('common.networkError'));
        console.error('获取提现记录失败:', error);
      }).finally(() => {
        this.loading = false;
        this.refreshing = false;
      });
    },
    
    getStatusClass(status) {
      switch(status) {
        case 1: return 'status-pending';
        case 2: return 'status-success';
        case 3: return 'status-failed';
        default: return 'status-failed';
      }
    },
    
    getStatusText(status) {
      return this.statusExt[status] || this.$t('withdraw.status3');
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.loading = true;
      this.getUserWithdrawList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container {
  width: 100%;
  min-height: 100vh;
  background: white;
}

/* 顶部导航栏样式 - 填充渐变色 */
.custom-nav-bar {
  height: 3.5rem;
  line-height: 3.5rem;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  position: relative;
  z-index: 10;
}

.custom-nav-bar::after {
  display: none;
}

.van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: white !important;
  font-weight: 600;
  font-size: 1.1rem;
}

.van-nav-bar__left {
  padding: 0 15px;
}

.van-nav-bar__left .van-icon {
  color: white !important;
  font-size: 1.2rem;
  font-weight: bold;
}

/* 主内容区域 */
.main {
  position: relative;
  overflow: auto;
  background-color: white;
  height: 100%;
  padding: 1rem;
}

.list-container {
  max-width: 100%;
}

/* 自定义单元格组 */
.custom-cell-group {
  background: transparent;
  border: none;
}

.custom-cell-group::after,
.custom-cell-group::before {
  display: none;
}

/* 每个栏目带边框 */
.custom-cell {
  margin-bottom: 0.8rem;
  border: 1.5px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.2rem;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.custom-cell:active {
  background-color: #f8f9ff;
  border-color: #667eea;
  transform: translateY(1px);
}

.custom-cell::after {
  display: none;
}

/* 单元格标题区域 - 优化布局 */
.cell-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 1rem;
}

.cell-left {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  flex: 1;
}

.title-text {
  font-weight: 600;
  color: #333;
  font-size: 1rem;
}

.amount {
  color: #667eea;
  font-weight: 600;
  font-size: 1.1rem;
}

/* 中间状态区域 */
.cell-middle {
  display: flex;
  justify-content: center;
  min-width: 70px;
}

/* 右侧通知按钮区域 */
.cell-right {
  display: flex;
  justify-content: flex-end;
  min-width: 60px;
}

.notification-btn {
  color: #667eea;
  font-size: 0.8rem;
  padding: 0.3rem 0.6rem;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  line-height: 1.2;
  height: auto;
}

.notification-btn:active {
  background: rgba(102, 126, 234, 0.2);
  transform: scale(0.95);
}

/* 状态样式 - 调整为和通知按钮相同大小 */
.status {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  white-space: nowrap;
  text-align: center;
  line-height: 1.2;
  height: auto;
}

.status-pending {
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.1);
}

.status-success {
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
}

.status-failed {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.time-label {
  color: #969799;
  font-size: 0.8rem;
  margin-top: 0.3rem;
}

/* 空状态样式 */
.custom-empty {
  padding: 3rem 1rem;
}

::v-deep .van-empty__description {
  color: #969799;
  font-size: 0.9rem;
}

/* 下拉刷新样式 */
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #667eea;
  font-size: 0.9rem;
}

::v-deep .van-loading__text {
  color: #969799;
  font-size: 0.9rem;
}

/* 列表加载状态 */
::v-deep .van-list__finished-text {
  color: #969799;
  font-size: 0.9rem;
  padding: 1rem 0;
  text-align: center;
}

/* 动画效果 */
@keyframes fadeInUp {
  from { 
    opacity: 0; 
    transform: translateY(15px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

.custom-cell {
  animation: fadeInUp 0.4s ease forwards;
}

/* 响应式调整 */
@media (max-width: 320px) {
  .main {
    padding: 0.8rem;
  }
  
  .custom-cell {
    padding: 1rem;
    margin-bottom: 0.6rem;
  }
  
  .cell-header {
    gap: 0.5rem;
  }
  
  .cell-middle {
    min-width: 60px;
  }
  
  .cell-right {
    min-width: 50px;
  }
  
  .notification-btn {
    font-size: 0.75rem;
    padding: 0.2rem 0.5rem;
  }
  
  .status {
    font-size: 0.75rem;
    padding: 0.2rem 0.5rem;
  }
}

/* 平板端优化 */
@media (min-width: 768px) {
  .main {
    padding: 1.5rem;
  }
  
  .custom-cell {
    padding: 1.5rem;
  }
  
  .cell-middle {
    min-width: 80px;
  }
  
  .cell-right {
    min-width: 70px;
  }
  
  .notification-btn {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
  }
  
  .status {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
  }
}
</style>